import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import { FeatherModule } from 'angular-feather';
import { allIcons } from 'angular-feather/icons';
import { SpecialDatatableModule } from '../../../shared/components/special-datatable/special-datatable.module';
import { DataFeedService } from '../../../shared/api/datafeed.service';
import { ReportViewModule } from '../report-view/report-view.module';
import { ReportsRollupCompanyCampaignsComponent } from '../reports-rollup-company-main/reports-rollup-company-main.component';
import { ReportsRollupReportViewComponent } from '../reports-rollup-report-view/reports-rollup-report-view.component';
import { ReportsRollupReportViewProgressComponent } from '../reports-rollup-report-view-progress/reports-rollup-report-view-progress.component';

@NgModule({
  declarations: [
    ReportsRollupCompanyCampaignsComponent,
    ReportsRollupReportViewComponent,
    ReportsRollupReportViewProgressComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    NgSelectModule,
    TranslateModule,
    FeatherModule.pick(allIcons),
    SpecialDatatableModule,
    ReportViewModule
  ],
  providers: [DataFeedService],
  exports: [ReportsRollupCompanyCampaignsComponent]
})
export class ReportsRollupWorkflowModule {}